import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Checkbox, IconButton } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import MDTypography from 'components/MDTypography';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import ClearIcon from '@mui/icons-material/Clear';
import OutlinedInput from '@mui/material/OutlinedInput';

import { getAllPropertyTypes } from 'services/property-type.service';
import useIsComponentMounted from 'hooks/useIsComponentMounted';

const AsyncMultiDropdown = ({ onChange }) => {
  const isComponentMounted = useIsComponentMounted();
  const [isLoading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const fetchPropertyTypes = useCallback(
    async (cancelToken) => {
      try {
        if (!isComponentMounted.current) return;
        setLoading(true);
        const response = await getAllPropertyTypes(cancelToken);
        setOptions([...(response.data?.data?.propertyTypes ?? [])]);
      } catch (error) {
        console.log({ error });
        if (error?.code === 'ERR_CANCELED') return;
      } finally {
        isComponentMounted.current && setLoading(false);
      }
    },
    [isComponentMounted]
  );
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 400,
      },
    },
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedOptions(value);
    onChange(value);
  };

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    fetchPropertyTypes(source.token);

    return () => source.cancel('Component got unmounted');
  }, []);
  return (
    <FormControl sx={{ minHeight: 48 }} fullWidth>
      <InputLabel id="property-type">Property type</InputLabel>
      <Select
        labelId="property-type"
        id="property-type-multi"
        multiple
        value={selectedOptions}
        onChange={handleChange}
        input={<OutlinedInput label="Property type" />}
        renderValue={(selected) => selected?.map((val) => val.name).join(', ')}
        MenuProps={MenuProps}
        endAdornment={
          <IconButton
            sx={{
              visibility: selectedOptions.length > 0 ? 'visible' : 'hidden',
              position: 'absolute',
              right: '25px',
              marginRight: '0',
            }}
            style={{
              backgroundColor: 'white',
            }}
            onClick={() => {
              setSelectedOptions([]);
              onChange([]);
            }}
            size="small"
          >
            <ClearIcon />
          </IconButton>
        }
      >
        {isLoading && (
          <MenuItem>
            <MDTypography display="inline" fontSize="14px" color="text">
              Loading...
            </MDTypography>
          </MenuItem>
        )}
        {options.map((type) => (
          <MenuItem sx={{padding: '5px 0'}} key={type.propertyTypeId} value={type} name={type.name}>
            <Checkbox
              checked={selectedOptions.indexOf(type) > -1}
              name={type.name}
            />
            <MDTypography display="inline" fontSize="14px" color="text">
              {type.name}
            </MDTypography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

AsyncMultiDropdown.propTypes = {
  onChange: PropTypes.func,
};

AsyncMultiDropdown.defaultProps = {
  onChange: () => {},
};

export default AsyncMultiDropdown;
